import { Scrollbars } from 'react-custom-scrollbars-2';
import { Component } from 'react';

class ScrollbarsCustom extends Component {
    render() {
        return (
            <Scrollbars
                onScroll={this.handleScroll}
                onScrollFrame={this.handleScrollFrame}
                onScrollStart={this.handleScrollStart}
                onScrollStop={this.handleScrollStop}
                onUpdate={this.handleUpdate}
                renderView={this.renderView}
                renderTrackHorizontal={this.renderTrackHorizontal}
                renderTrackVertical={this.renderTrackVertical}
                renderThumbHorizontal={this.renderThumbHorizontal}
                renderThumbVertical={this.renderThumbVertical}
                autoHide
                autoHideTimeout={1000}
                autoHideDuration={200}
                autoHeightMin={0}
                thumbMinSize={30}
                universal={true}
                {...this.props}
            />
        );
    }
}

export default ScrollbarsCustom;
